export const CarsharingNetworkRequests = {
  addons: "/api/v3/addons",
  addonTypes: "/api/v3/addon_types",
  associateCustomerToBusiness:
    "/api/v3/fleet_rentals/actions/associate_customer_to_business",
  associateVehicleDriver: (id) =>
    `api/v3/fleet_rentals/${id}/actions/reservation/associate_customer_vehicle`,
  cancelScheduledRental: (id) =>
    `/api/v3/scheduled_rentals/${id}/actions/cancel_rental/`,
  carsharingRental: (id) => `/api/v3/rentals/${id}`,
  createCarSharingRental: `/api/v3/rentals/`,
  createContract: () =>
    "/api/v3/scheduled_rentals/contract_scheduled_rental_requests",
  endCarSharingRental: (id) => `/api/v3/rentals/${id}/actions/end_rental`,
  getAddon: (id) => `/api/v3/addons/${id}`,
  getAddonType: (id) => `/api/v3/addon_types/${id}`,
  getLeasingAddonsRate: () => "/api/v3/get_leasing_addons_rate",
  getSubscription: () =>
    "/api/v3/scheduled_rentals/contract_scheduled_rental_requests",
  getSubscriptionProviderConfig: () =>
    "/api/v3/subscription_provider_configuration",
  getCustomerRentalInfo: "api/v3/rentals?role=CUSTOMER&in_progress=true",
  getMarket: (id) => `/api/v3/markets/${id}`,
  getSupportPhoneNumber: "/api/v3/support_phone_numbers",
  inspectionReport: (rentalId, vehicleId) =>
    `api/v3/fleet_rentals/${rentalId}/actions/get_inspection_report?vehicle_id=${vehicleId}`,
  jumioAuthStatus: (customerId, workflowId) =>
    `api/v3/customers/${customerId}/actions/iproov_workflow_details?workflow_id=${workflowId}`,
  markets: "/api/v3/markets",
  policyDocuments: "/api/v3/agreements/policy_documents/",
  ratings: (id) => `api/v3/rentals/${id}/ratings/`,
  removeVehicleFromFleet: (id) =>
    `/api/v3/fleet_rentals/${id}/actions/remove_vehicles`,
  rental: "/api/v3/rentals",
  rentalAgreement: (rentalId, vehicleId, customerId) =>
    `api/v3/fleet_rentals/${rentalId}/actions/get_rental_agreement?vehicle_id=${vehicleId}&customer_id=${customerId}`,
  rentalInfo: (id) => `api/v3/vehicles/${id}/rental_info`,
  scheduleRental: "/api/v3/scheduled_rentals",
  signInspectionReport: (rentalId) =>
    `api/v3/fleet_rentals/${rentalId}/actions/sign_inspection_report`,
  signRentalAgreement: (rentalId) =>
    `api/v3/fleet_rentals/${rentalId}/actions/sign_rental_agreement`,
  stationAvailableVehicleTypes:
    "api/v3/scheduled_rentals/station_available_vehicle_types",
  stationEndDates: "/api/v3/scheduled_rentals/station_available_end_dates",
  stationEndTimes: "/api/v3/scheduled_rentals/station_available_end_times",
  stations: "/api/v3/services/stations",
  serviceAvailableStartDates: "/api/v3/scheduled_rentals/available_start_dates",
  serviceAvailableStartTimes: "/api/v3/scheduled_rentals/available_start_times",
  stationStartDates: "/api/v3/scheduled_rentals/station_available_start_dates",
  stationStartTimes: "/api/v3/scheduled_rentals/station_available_start_times",
  stationVehicleTypes: "/api/v3/scheduled_rentals/available_vehicle_types",
  tripactivities: "/api/v3/activities",
  updateDoorStatus: (vehicleId) =>
    `/api/v3/vehicles/${vehicleId}/actions/update_door_status/`,
  vehicleCheckoutJumioAuthentication:
    "api/v3/customers/actions/ext_verification",
  vehicleTypes: (id) => `api/v3/vehicle_types/${id}`,
  vehicleTypeLeasingEntities: "/api/v3/vehicle_type_leasing_entities",
  vehicleTypeLeasingEntityDetails: (id) =>
    `api/v3/vehicle_type_leasing_entities/${id}`,
  vehicleList: (id) => `api/v3/business_entity/${id}/preferred_group_vehicles`,
};
